import React from 'react';
import './LandmarkModal.css';
import { Landmark } from '../types';

interface LandmarkModalProps {
  landmark: Landmark;
  onClose: () => void;
}

const LandmarkModal: React.FC<LandmarkModalProps> = ({ landmark, onClose }) => {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'wildlife':
        return '#4CAF50';
      case 'diving':
        return '#2196F3';
      case 'historical':
        return '#FF9800';
      case 'safety':
        return '#F44336';
      case 'camp':
        return '#9C27B0';
      default:
        return '#607D8B';
    }
  };

  const getCategoryLabel = (category: string) => {
    switch (category) {
      case 'wildlife':
        return 'Wildlife';
      case 'diving':
        return 'Diving Spot';
      case 'historical':
        return 'Historical Site';
      case 'safety':
        return 'Safety Information';
      case 'camp':
        return 'Camp Location';
      default:
        return 'Point of Interest';
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="modal-header">
          <h2>{landmark.name}</h2>
          <span 
            className="category-badge"
            style={{ backgroundColor: getCategoryColor(landmark.category) }}
          >
            {getCategoryLabel(landmark.category)}
          </span>
        </div>

        <div className="modal-body">
          {landmark.imageUrl ? (
            <div className="modal-image">
              <img src={landmark.imageUrl} alt={landmark.name} />
            </div>
          ) : (
            <div className="modal-image" style={{ background: 'linear-gradient(135deg, #a8e6cf 0%, #88d8a3 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: '4rem', opacity: 0.6 }}>🏝️</span>
            </div>
          )}
          
          <div className="modal-description-wrapper">
            <div className="modal-description">
              <p>{landmark.description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandmarkModal;

